import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createBill, getApprovedForms } from "../../api/Api";
import logo from "../../Assets/Kalam Kids Logo_newlogo.png";

const AddBill = ({ onBack }) => {
  const [query, setQuery] = useState("");
  const [approvedForms, setApprovedForms] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [payAmount, setPayAmount] = useState("");
  const [cashReceivedFrom, setCashReceivedFrom] = useState("");
  const [relationshipName, setRelationshipName] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [loading, setLoading] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [cashMode, setCashMode] = useState("Cash");
  const [submitted, setSubmitted] = useState(false);
  const [filteredForms, setFilteredForms] = useState([]);
  const [amountInWordsError, setAmountInWordsError] = useState("");

  // New state variables for additional payment details
  const [chequeDetails, setChequeDetails] = useState("");
  const [qrTransactionId, setQrTransactionId] = useState("");
  const [bankTransferId, setBankTransferId] = useState("");
  const [cashDenominations, setCashDenominations] = useState("");
  const [billDate, setBillDate] = useState(new Date().toISOString().split("T")[0]);

  // const { totalPaid, totalRemaining } = React.useMemo(() => {
  //   const totalAmount = approvedForms.reduce(
  //     (acc, form) => acc + (form.feeAmount || 0),
  //     0
  //   );
  //   const totalPaid = approvedForms.reduce(
  //     (acc, form) => acc + (form.paidFee || 0),
  //     0
  //   );
  //   return {
  //     totalPaid,
  //     totalRemaining: totalAmount - totalPaid,
  //   };
  // }, [approvedForms]);

  const fetchApprovedForms = async () => {
    try {
      const data = await getApprovedForms(""); // Fetch all academic years
      setApprovedForms(data.data);
      setFilteredForms(data.data);
    } catch (err) {
      console.error("Error fetching approved forms", err);
    }
  };

  useEffect(() => {
    fetchApprovedForms();
  }, []);
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setQuery(val);

    // Group forms by student (invoiceNo) to calculate total debt and find latest record
    const studentsMap = approvedForms.reduce((acc, f) => {
      if (!acc[f.invoiceNo]) {
        acc[f.invoiceNo] = {
          totalRemaining: 0,
          latestForm: f
        };
      }
      acc[f.invoiceNo].totalRemaining += (f.feeAmount - (f.paidFee || 0));
      if (f.academicYear > acc[f.invoiceNo].latestForm.academicYear) {
        acc[f.invoiceNo].latestForm = f;
      }
      return acc;
    }, {});

    const filtered = Object.values(studentsMap)
      .filter(({ totalRemaining, latestForm: f }) => {
        return (
          totalRemaining > 0 &&
          (f.invoiceNo.toLowerCase().includes(val.toLowerCase()) ||
            (f.particularsOfChild?.fullName &&
              f.particularsOfChild.fullName
                .toLowerCase()
                .includes(val.toLowerCase())) ||
            (f.admissionFor &&
              f.admissionFor.toLowerCase().includes(val.toLowerCase())))
        );
      })
      .map(s => s.latestForm);

    setFilteredForms(filtered);
  };

  const handleSelectForm = (form) => {
    setSelectedForm(form);
    setPayAmount("");
    setCashReceivedFrom("");
    setRelationshipName("");
    setReceiverName("");
    setAmountInWords("");
    setCashMode("Cash");
    setSubmitted(false);
    setQuery(form.invoiceNo);
    setFilteredForms([]);
    setChequeDetails("");
    setQrTransactionId("");
    setBankTransferId("");
  };

  const isValidAmountInWords = (words) => {
    return typeof words === "string" && /^[a-zA-Z\s]+$/.test(words.trim());
  };

  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const getTwoDigits = (n) => {
      if (n < 10) return ones[n];
      else if (n < 20) return teens[n - 10];
      else
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
    };

    const getThreeDigits = (n) => {
      if (n === 0) return "";
      const hundred = Math.floor(n / 100);
      const rest = n % 100;
      return (
        (hundred ? ones[hundred] + " hundred" + (rest ? " and " : "") : "") +
        getTwoDigits(rest)
      );
    };

    if (num === 0) return "zero";

    let result = "";

    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = Math.floor(num % 1000);

    if (crore) result += getTwoDigits(crore) + " crore ";
    if (lakh) result += getTwoDigits(lakh) + " lakh ";
    if (thousand) result += getTwoDigits(thousand) + " thousand ";
    if (hundred) result += getThreeDigits(hundred);

    return result.trim();
  };

  const handlePayAmountChange = (e) => {
    const val = e.target.value;
    setPayAmount(val);
    if (val) {
      const words = numberToWords(parseFloat(val));
      setAmountInWords(words);
      if (!isValidAmountInWords(words)) {
        setAmountInWordsError("Please enter a valid amount in words.");
      } else {
        setAmountInWordsError("");
      }
    } else {
      setAmountInWords("");
      setAmountInWordsError("");
    }
  };

  const totalRemaining = selectedForm
    ? approvedForms
        .filter((f) => f.invoiceNo === selectedForm.invoiceNo)
        .reduce((acc, f) => acc + (f.feeAmount - (f.paidFee || 0)), 0)
    : 0;

const handleSubmit = async () => {
  if (
    !payAmount ||
    !cashReceivedFrom ||
    !relationshipName ||
    !receiverName ||
    !amountInWords
  ) {
    toast.error("Please fill in all required fields.");
    return;
  }

  setLoading(true);

  try {
    let remainingAmount = parseFloat(payAmount);

    // Get all pending forms for same student
    const studentForms = approvedForms
      .filter((f) => f.invoiceNo === selectedForm.invoiceNo)
      .sort((a, b) =>
        a.academicYear.localeCompare(b.academicYear)
      ); // oldest first

    for (const form of studentForms) {
      const pending =
        (form.feeAmount || 0) - (form.paidFee || 0);

      if (pending <= 0) continue;

      if (remainingAmount <= 0) break;

      // Amount to pay for this year
      const payNow = Math.min(pending, remainingAmount);

      const data = {
        amount: payNow,
        paidBy: cashMode,
        cashReceivedFrom,
        relationshipName,
        amountInWords,
        chequeDetails,
        qrTransactionId,
        bankTransferId,
        cashDenominations,
        receiverName,
        date: billDate,
        remainingBalance: pending - payNow,
        academicYear: form.academicYear,
      };

      // Submit payment for this academic year
      await createBill(form, data);

      remainingAmount -= payNow;
    }

    setSubmitted(true);

    toast.success("🎉 Payment submitted successfully!");

    fetchApprovedForms();

    setTimeout(() => {
      onBack(true);
    }, 1000);
  } catch (err) {
    console.error("Payment failed", err);

    toast.error("❌ Payment failed. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const remaining = totalRemaining;

  const cashOptions = ["Cash", "QR", "Bank Transfer", "Cheque"];

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-xl shadow-md">
      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            .print\\:hidden {
              display: none;
            }
            table, th, td {
              border: 1px solid #000;
              border-collapse: collapse;
            }
          }
        `}
      </style>

      <h2 className="text-[#16bab1]xl font-bold mb-6 text-gray-800">
        🧾Add Bill
      </h2>
      {/* <div className="flex justify-around mb-6 p-4 bg-gray-100 rounded-lg">
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-700">Total Paid</p>
          <p className="text-2xl font-bold text-green-600">
            ₹{totalPaid.toLocaleString()}
          </p>
        </div>
        <div className="text-center">
          <p className="text-lg font-semibold text-gray-700">Total Remaining</p>
          <p className="text-2xl font-bold text-red-600">
            ₹{totalRemaining.toLocaleString()}
          </p>
        </div>
      </div> */}

      {/* 🔍 Search Box */}
      <div className="relative mb-6">
        <input
          type="text"
          className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Type invoice number..."
          value={query}
          onChange={handleSearchChange}
        />
        {filteredForms.length > 0 && query && (
          <ul className="absolute z-10 w-full bg-white border border-gray-200 mt-1 rounded-md shadow max-h-60 overflow-y-auto">
            {filteredForms.map((form) => (
              <li
                key={form._id}
                onClick={() => handleSelectForm(form)}
                className="px-4 py-2 hover:bg-blue-100 cursor-pointer transition"
              >
                <span className="font-semibold text-blue-700">
                  {form.invoiceNo}
                </span>{" "}
                - {form.particularsOfChild?.fullName}-{form.admissionFor} ({form.academicYear})
              </li>
            ))}
          </ul>
        )}
      </div>

      {selectedForm && (
        <div className="max-w-3xl mx-auto border border-gray-400 p-6 font-sans text-[16px] text-gray-800">
          {/* Header */}
          <div className="text-[#16bab1]enter mb-6">
            <p className="text-xl font-semibold mt-1 text-gray-600">
              FEE RECEIPT
            </p>
          </div>

          {/* CR & Date */}
          <div className="flex justify-between p-5 mb-6">
            <div>
              <img src={logo} alt="logo" className="w-44" />
            </div>
            <div className="flex flex-col space-y-2">
              <div className="flex space-x-1 items-center">
                <label className="bg-[#16bab1] text-white w-36 px-2 py-1">
                  CR. No:
                </label>
                <span className="bg-gray-200 px-3 py-1 flex-1">
                  {selectedForm?.invoiceNo}
                </span>
              </div>
              <div className="flex items-center">
                <label className="bg-[#16bab1] text-white w-36 px-2 py-1">
                  Date:
                </label>
                <input
                  type="date"
                  value={billDate}
                  onChange={(e) => setBillDate(e.target.value)}
                  className="bg-gray-200 px-3 py-1 flex-1 outline-none"
                />
              </div>
            </div>
          </div>

          {/* Form Fields */}
          <div className="grid grid-cols-[2fr_1fr] gap-4 mb-6">
            {/* Left Column */}
            <div>
              {[
                {
                  label: "Received With:",
                  element: (
                    <input
                      type="text"
                      className="bg-gray-200 outline-none px-3 py-1 flex-1"
                      placeholder="Name*"
                      value={cashReceivedFrom}
                      onChange={(e) => setCashReceivedFrom(e.target.value)}
                    />
                  ),
                },
                {
                  label: "Relationship:",
                  element: (
                    <input
                      type="text"
                      className="bg-gray-200 outline-none px-3 py-1 flex-1"
                      placeholder="Relationship*"
                      value={relationshipName}
                      onChange={(e) => setRelationshipName(e.target.value)}
                    />
                  ),
                },
                {
                  label: "Admission No:",
                  element: (
                    <p className="bg-gray-200 px-3 py-1 flex-1">
                      {selectedForm?.invoiceNo}
                    </p>
                  ),
                },
                {
                  label: "Student Name:",
                  element: (
                    <p className="bg-gray-200 px-3 py-1 flex-1">
                      {selectedForm?.particularsOfChild?.fullName}
                    </p>
                  ),
                },
                {
                  label: "Class:",
                  element: (
                    <p className="bg-gray-200 px-3 py-1 flex-1">
                      {selectedForm?.admissionFor}
                    </p>
                  ),
                },
                {
                  label: "Academic Year:",
                  element: (
                    <p className="bg-gray-200 px-3 py-1 flex-1">
                      {selectedForm?.academicYear}
                    </p>
                  ),
                },
                {
                  label: "Total Remaining Balance:",
                  element: (
                    <p className="bg-gray-200 px-3 py-1 flex-1">₹{totalRemaining}</p>
                  ),
                },
                {
                  label: "Year-wise Breakdown:",
                  element: (
                    <div className="flex-1 space-y-2">
                      {Object.entries(
                        approvedForms
                          .filter(f => f.invoiceNo === selectedForm.invoiceNo)
                          .reduce((acc, f) => {
                            const year = f.academicYear || "Unknown Year";
                            if (!acc[year]) acc[year] = 0;
                            acc[year] += (f.feeAmount - (f.paidFee || 0));
                            return acc;
                          }, {})
                      )
                        .sort((a, b) => b[0].localeCompare(a[0]))
                        .map(([year, pending]) => (
                          <div key={year} className="flex justify-between bg-gray-200 px-3 py-1">
                            <span className="font-medium">{year} Bill:</span>
                            <span>₹{pending}</span>
                          </div>
                        ))}
                    </div>
                  ),
                },
              ].map(({ label, element }, i) => (
                <div key={i} className="flex space-x-1 items-center mb-4">
                  <label className="bg-[#16bab1] text-white text-nowrap w-44 px-2 py-1">
                    {label}
                  </label>
                  {element}
                </div>
              ))}
            </div>

            {/* Right Column */}
            <div>
              <div className="mb-4">
                <label className="bg-[#16bab1] text-white w-full px-2 py-1 inline-block">
                  Mode of Payment:
                </label>
                <div className="grid grid-cols-2 gap-2 mt-2">
                  {cashOptions.map((option) => (
                    <div
                      key={option}
                      onClick={() => {
                        setCashMode(option);
                        setChequeDetails("");
                        setQrTransactionId("");
                        setBankTransferId("");
                      }}
                      className={`cursor-pointer capitalize px-2 py-2 border rounded text-center ${cashMode === option
                        ? "bg-[#16bab1] text-white border-[#226a69]"
                        : "border-gray-400 text-gray-700"
                        }`}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              </div>
              {cashMode === "Cash" && (
                <div className="mb-4 flex flex-col">
                  <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                    Cash Denomination
                  </label>
                  <textarea
                    className="bg-gray-200 outline-none px-2 py-1 flex-1"
                    value={cashDenominations}
                    onChange={(e) => setCashDenominations(e.target.value)}
                    rows={2}
                    placeholder="e.g. 500 x 2, 100 x 5"
                  />
                </div>
              )}
              {cashMode === "QR" && (
                <div className="mb-4 flex flex-col">
                  <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                    QR Transaction ID:
                  </label>
                  <input
                    type="text"
                    className="bg-gray-200 outline-none px-2 py-1 flex-1"
                    placeholder="Transaction ID"
                    value={qrTransactionId}
                    onChange={(e) => setQrTransactionId(e.target.value)}
                  />
                </div>
              )}

              {cashMode === "Bank Transfer" && (
                <div className="mb-4 flex flex-col">
                  <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                    Bank Transfer ID:
                  </label>
                  <input
                    type="text"
                    className="bg-gray-200 outline-none px-2 py-1 flex-1"
                    value={bankTransferId}
                    placeholder="Transaction ID"
                    onChange={(e) => setBankTransferId(e.target.value)}
                  />
                </div>
              )}

              {cashMode === "Cheque" && (
                <div className="mb-4 flex flex-col">
                  <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                    Cheque Details:
                  </label>
                  <input
                    type="text"
                    className="bg-gray-200 outline-none px-2 py-1 flex-1"
                    placeholder="Cheque Detail"
                    value={chequeDetails}
                    onChange={(e) => setChequeDetails(e.target.value)}
                  />
                </div>
              )}

              <div className="flex flex-col mb-4">
                <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                  Paid Amount ₹
                </label>
                <input
                  type="number"
                  className="bg-gray-200 outline-none px-2 py-1 flex-1"
                  placeholder="Amount"
                  value={payAmount}
                  onChange={handlePayAmountChange}
                />
              </div>
              <div className="flex flex-col mb-4">
                <label className="bg-[#16bab1] text-white w-full px-2 py-1">
                  New Balance
                </label>
                <p className="bg-gray-200 px-2 py-1 flex-1">
                  ₹{remaining - (parseFloat(payAmount) || 0)}
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center mb-4">
            <label className="bg-[#16bab1] text-white w-36 px-2 py-1">
              Rs. (in words):
            </label>
            <input
              type="text"
              className="bg-gray-200 outline-none w-full px-4 py-1"
              placeholder="(In Words)"
              value={amountInWords}
              readOnly
            />
          </div>
          <div className=" flex justify-end">
            <div className="mb-4 flex flex-col  justify-end  w-48 ">
              <label className="bg-[#16bab1] text-white w-48 px-2 py-1">
                Receiver Name:
              </label>
              <input
                type="text"
                className="bg-gray-200 outline-none px-3 py-1 flex-1"
                value={receiverName}
                placeholder="Enter receiver name*"
                onChange={(e) => setReceiverName(e.target.value)}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center mt-6">
            <p className="text-left italic text-sm leading-5 text-[#16bab1]">
              Cell: 9994558487, 9488440066 • Website: www.kalamkids.in
              <br />
              #23, New Shankaranpalayam Road, Near Tollgate, Vellore - 632 001.
              TN.
            </p>
            <button
              onClick={handleSubmit}
              className="bg-[#16bab1] text-white px-6 py-2 rounded hover:bg-green-700"
              disabled={loading} // Disable button while loading
            >
              {loading ? "Submitting..." : "Submit"} {/* Show loading text */}
            </button>
            <button
              type="button"
              onClick={() => window.history.back()}
              className="bg-[#F36743] text-white px-6 py-2 rounded hover:bg-green-700"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddBill;
